import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { EditProductRequestBody, Product } from './product.types';

export const useProducts = (enabled: boolean = false, requestBody?: { classNo?: number; statusNo?: number }) => {
  return useQuery<AxiosResponse<Product[]>>({
    queryKey: ['products', requestBody?.classNo, requestBody?.statusNo],
    queryFn: () => apiClient.get<Product[]>('/products', { params: requestBody }),
    enabled,
  });
};

export const useProduct = (requestBody: {productNo: string; classNo: string}, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Product>>({
    queryKey: ['product', requestBody.classNo, requestBody.productNo],
    queryFn: () => apiClient.get<Product>(`/products/${requestBody.productNo}`, { params: requestBody }),
    enabled,
  });
};

export const useEditProduct = (productNo: string) => {
  return useMutation((requestBody: EditProductRequestBody) => {
    return apiClient.put(`/products/${productNo}`, requestBody);
  })
};

export const useGetRecipeProducts = (
  requestBody: { classNo: string; baseNo: string; sizeNo: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Product[]>>({
    queryKey: ['getRecipeProducts', requestBody.classNo, requestBody.baseNo, requestBody.sizeNo],
    queryFn: () => apiClient.get<Product[]>('/recipes/products', { params: requestBody }),
    enabled
  });
};

export const useGetSubRecipeProducts = (
  requestBody: { classNo: string; baseNo?: string; sizeNo?: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Product[]>>({
    queryKey: ['getSubRecipeProducts', requestBody.classNo, requestBody.baseNo, requestBody.sizeNo],
    queryFn: () => apiClient.get<Product[]>('/sub-recipes/products', { params: requestBody }),
    enabled
  });
};